<section>
  <div class="container mt-3">
    <form>
      <div class="input-group mb-3">
        <span class="input-group-text">SR</span>
        <input id="origen_nombre" [(ngModel)]="idsr" type="number" aria-label="Nombre" class="form-control">
        <span class="input-group-text">ET</span>
        <input id="origen_nombre" [(ngModel)]="idet" type="number" aria-label="Nombre" class="form-control">
        <span class="input-group-text">DNI</span>
        <input id="origen_nombre" [(ngModel)]="dni" type="number" aria-label="Nombre" class="form-control">
      </div>
      <div class="input-group mb-3">

          <!-- <mat-label>Desde</mat-label> -->
          <span class="input-group-text">Desde</span>
          <input class="form-control" matInput [matDatepicker]="desde" >
          <mat-datepicker-toggle matSuffix [for]="desde"></mat-datepicker-toggle>
          <mat-datepicker #desde></mat-datepicker>

          <span class="input-group-text">Hasta</span>
          <input class="form-control" matInput [matDatepicker]="hasta" >
          <mat-datepicker-toggle matSuffix [for]="hasta" ></mat-datepicker-toggle>
          <mat-datepicker #hasta></mat-datepicker>

          <span class="input-group-text" id="inputGroup-sizing-default">Estado</span>
          <select class="form-select" aria-label="Select Vehiculo" [(ngModel)]="estado">
            <option *ngFor="let m of estados" value={{m.id}}>{{m.descripcion}}</option>
          </select>
          <div class="form-floating text-center justify-content-md-end mb-1">
            <button class="btn btn-primary" type="button" (click)="buscar()">Buscar</button>
          </div>
      </div>
      <!-- <button class="btn btn-success" (click)="open(0)">Nuevo</button> -->
      <table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark">
        <thead class="table-dark">
          <tr>
            <th scope="col">SR</th>
            <th scope="col">Nombre</th>
            <th scope="col">DNI</th>
            <th scope="col">Direccion</th>
            <th scope="col">Demora</th>
            <th scope="col">Fecha Solicitada</th>
            <th scope="col">Estado</th>
            <th scope="col">ET Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody class="table-light">

          <tr *ngFor="let m of sr">
            <th *ngIf="m.demora>5">SR-{{m.id| number:'6.0':'fr'}}</th>
            <th *ngIf="m.demora>5">{{m.nombreApellido}}</th>
            <th *ngIf="m.demora>5">{{m.dni}}</th>
            <th *ngIf="m.demora>5">{{m.DIRECCION}}</th>
            <th *ngIf="m.demora>5" class="text-center bg-warning">{{m.demora}}</th>
            <th *ngIf="m.demora>5">{{m.created_at}}</th>
            <th *ngIf="m.demora>5">{{m.estadoDescripcion}}</th>
            <th *ngIf="m.demora>5">{{m.etEstadoDescripcion}}</th>
            <!--Si demora > 5 dias-->
            <th *ngIf="(m.demora>5)">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- <button *ngIf="(m.estado===1)" type="button" class="btn btn-primary btn-sm" (click)="cambiarEstado(m.id,2)">Aprobar</button> -->
                <!-- <button *ngIf="(m.estado===2)" type="button" class="btn btn-success btn-sm" (click)="abrirEt(m.id)">Recibir</button> -->
                <button *ngIf="(m.estado===3)" type="button" class="btn btn-success btn-sm" (click)="abrirEtM(m.id_et, m.id)">ET-{{m.id_et| number:'6.0':'fr'}}</button>
                <button type="button" class="btn btn-warning btn-sm" (click)="open(m.id)">Modificar</button>
                <!-- <button  type="button" class="btn btn-danger btn-sm" (click)="cambiarEstado(m.id,4)">Cancelar</button> -->
              </div>
            </th>
            <th *ngIf="m.demora<=5">SR-{{m.id| number:'6.0':'fr'}}</th>
            <th *ngIf="m.demora<=5">{{m.nombreApellido}}</th>
            <th *ngIf="m.demora<=5">{{m.dni}}</th>
            <th *ngIf="m.demora<=5">{{m.DIRECCION}}</th>
            <th *ngIf="m.demora<=5" class="text-center">{{m.demora}}</th>
            <th *ngIf="m.demora<=5">{{m.created_at}}</th>
            <th *ngIf="m.demora<=5">{{m.estadoDescripcion}}</th>
            <th *ngIf="m.demora<=5" >{{m.etEstadoDescripcion}}</th>
            <!--Si demora <= 5 dias-->
            <th *ngIf="(m.demora<=5)" >
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- <button *ngIf="(m.estado===1)" type="button" class="btn btn-primary btn-sm" (click)="cambiarEstado(m.id,2)">Aprobar</button> -->
                <!-- <button *ngIf="(m.estado===2)" type="button" class="btn btn-success btn-sm" (click)="abrirEt(m.id)">Recibir</button> -->
                <button *ngIf="(m.estado===3)" type="button" class="btn btn-success btn-sm" (click)="abrirEtM(m.id_et, m.id)">ET-{{m.id_et| number:'6.0':'fr'}}</button>
                <button type="button" class="btn btn-warning btn-sm" (click)="open(m.id)">Modificar</button>
                <!-- <button  type="button" class="btn btn-danger btn-sm" (click)="cambiarEstado(m.id,4)">Cancelar</button> -->
              </div>
            </th>

          </tr>

        </tbody>
      </table>
    </form>
  </div>
</section>
